<template>
  <b-modal
    id="modal-select-user"
    centered
    :title="header"
    :hide-header="!header"
    hide-footer
    :size="size || 'md'"
    :no-close-on-backdrop="true"
  >
    <b-form @submit.prevent="submit">
      <b-form-group id="input-group-users">
        <v-select
          v-model="selectedUser"
          v-validate="{ required: true }"
          :options="users"
          label="user_name"
          placeholder="Select a user"
          data-vv-name="user"
        ></v-select>
      </b-form-group>

      <b-row>
        <b-col class="text-right">
          <b-btn variant="primary" type="submit">Select</b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "UserSelectModal",
  components: {
    vSelect
  },
  props: {
    users: {
      type: Array,
      required: true
    },
    header: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedUser: null
    };
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return false;
        }

        this.$bvModal.hide("modal-select-user");
        this.$emit("submit", this.selectedUser);

        this.selectedUser = null;
      });
    }
  }
};
</script>
